import 'remodal';

// ------------------------------------------------
//	スクロールアニメーション（.anim → .active）
// ------------------------------------------------
const funcAnim = () => {
	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	const check = () => {
		const th = window.innerHeight * 0.9;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	check();
	if (document.readyState !== 'complete') {
		window.addEventListener('load', check, { once: true });
	}
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// ------------------------------------------------
//	ナビ出現：KV下端を通過したら左からふわっと出し、KVが見えたら引っ込める（SP固定ナビのみ）
//	PC左サイドは最初から表示
// ------------------------------------------------
const funcNaviShow = () => {
	const kv = document.getElementById('kv');
	const targets = [document.getElementById('navi')].filter(Boolean);
	if (!kv || !targets.length) return;

	const toggle = (on) => targets.forEach((el) => el.classList.toggle('is-show', on));

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			// KVが画面に入っている間は隠す。下端を通過している時だけ出す
			toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0);
		});
	}, { threshold: 0 });
	observer.observe(kv);
};

// ------------------------------------------------
//	現在セクションのハイライト（.area → 対応する li に is-current）
// ------------------------------------------------
const funcNav = () => {
	const areas = document.querySelectorAll('.area');
	const navGroups = [
		document.querySelectorAll('.side__nav > ul:first-child li'),
		document.querySelectorAll('.hr__navi li'),
	].filter((g) => g.length);
	if (!areas.length || !navGroups.length) return;

	const areasArray = [...areas];
	const check = (entries) => {
		entries.forEach((entry) => {
			const index = areasArray.indexOf(entry.target);
			if (index === -1) return;

			navGroups.forEach((items) => {
				if (entry.isIntersecting) {
					items.forEach((item) => item.classList.remove('is-current'));
					if (items[index]) items[index].classList.add('is-current');
				} else if (items[index]) {
					items[index].classList.remove('is-current');
				}
			});
		});
	};

	const observer = new IntersectionObserver(check, {
		rootMargin: '0px 0px -90% 0px',
		threshold: 0,
	});
	areas.forEach((target) => observer.observe(target));
};

// ------------------------------------------------
//	スムーススクロール（.anchor）
// ------------------------------------------------
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);

const funcSmoothScroll = () => {
	const duration = 500;
	document.querySelectorAll('.anchor').forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			const href = trigger.getAttribute('href');
			if (!href || !href.startsWith('#')) return;
			const target = document.getElementById(href.slice(1));
			if (!target) return;

			e.preventDefault();
			e.stopPropagation();

			const start = window.scrollY || 0;
			const dest = start + target.getBoundingClientRect().top;
			const dist = dest - start;
			const startTime = performance.now();

			const loop = (now) => {
				const nt = (now - startTime) / duration;
				if (nt < 1) {
					window.scrollTo(0, start + dist * easeInOut(nt));
					requestAnimationFrame(loop);
				} else {
					window.scrollTo(0, dest);
				}
			};
			requestAnimationFrame(loop);
		});
	});
};

window.addEventListener('DOMContentLoaded', () => {
	funcAnim();
	funcNaviShow();
	funcNav();
	funcSmoothScroll();
});
